import { Auth } from 'aws-amplify';
import useRuntimeConfig from '@vl-core/hooks/useConfig';

const useRedirectToAxaSSO = () => {
  const { IDENTITY_PROVIDERS } = useRuntimeConfig();

  return () => {
    const provider = IDENTITY_PROVIDERS?.providers?.find((p) => p?.provider === 'AXAPAT');

    if (!provider) return;

    // @ts-expect-error
    return Auth.federatedSignIn({ provider: provider.provider });
  };
};

export default useRedirectToAxaSSO;
